import {memoize, camelCase} from '@servicenow/ui-internal';

export default memoize(
	function toPropertyName(attrName) {
		return camelCase(attrName);
	},
	{profileName: 'toPropertyName'}
);
